export default __webpack_public_path__ + "static/media/zucchine.48ecd13a.mp3";